import React, { useState } from "react";
import AdminNavBar from "./AdminNavBar";
import Header from "./Header";
import SuperUserNavBar from "./SuperUserNavBar";
import UserNavBar from "./UserNavBar";
import "../index.css";
import "../component/AdminNavBar.css";
import Footer from "../components/Footer/Footer";

const Layout = ({ children }) => {
  const [activePage, setActivePage] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const storedUser = JSON.parse(localStorage.getItem("userRoles"));

  const renderNavBar = () => {
    if (storedUser == "ADMINUSER") {
      return (
        <AdminNavBar
          setActivePage={setActivePage}
          setSidebarOpen={setSidebarOpen}
        />
      );
    } else if (storedUser == "SUPERUSER") {
      return (
        <SuperUserNavBar
          setActivePage={setActivePage}
          setSidebarOpen={setSidebarOpen}
        />
      );
    } else {
      return (
        <UserNavBar
          setActivePage={setActivePage}
          setSidebarOpen={setSidebarOpen}
        />
      );
    }
  };

  return (
    <div className="flex">
      <main className="flex h-screen">
        <Header />
        <div
          className={`flex ${sidebarOpen ? "w-22-vw" : "w-[5.3vw]"} duration-500`}
        >
          {renderNavBar()}
        </div>
        <div
          className={`flex ${
            sidebarOpen ? "w-[76vw]" : "w-[93.5vw]"
          } pt-16 duration-500`}
        >
          {children}
        </div>
        <Footer /> {/* Added by Smita */}
      </main>
    </div>
  );
};

export default Layout;
